module.exports = __webpack_public_path__ + "img/new2.e9e1655a.png";